import { apiClient } from '@/lib/api/client';
import { endpoints } from '@/lib/api/endpoints';
import { parseContract } from '@/lib/api/parse';

import { toListQuery } from './filters';
import { paymentListResponseSchema, paymentTimelineSchema } from './schemas';
import type { PaymentListParams, PaymentListResponse, PaymentTimeline } from './types';

export { toListQuery };

/** Sort + filters → the list's wire params, defaults included. The export sends the same, so the
 *  file comes out with the rows and order on screen, sorted or not (ADO 120974). */
export function paymentsRequestQuery(params: Omit<PaymentListParams, 'page' | 'limit'>) {
  const { sortBy = 'paidAt', sortOrder = 'desc', ...filters } = params;
  return { sortBy, sortOrder, ...toListQuery(filters) };
}

/** Paginated/sorted/filtered/searchable payment-entry list. */
export async function listPayments(params: PaymentListParams): Promise<PaymentListResponse> {
  const { page, limit, ...rest } = params;
  const { data, meta } = await apiClient.getList(endpoints.payments.list, {
    params: { page, limit, ...paymentsRequestQuery(rest) },
  });
  return parseContract(paymentListResponseSchema, { data, meta }, endpoints.payments.list);
}

/** Per-entry timeline (header + temp→final events). 404 rejects as `ApiError` (status 404). */
export async function getPaymentTimeline(paymentId: string): Promise<PaymentTimeline> {
  return parseContract(
    paymentTimelineSchema,
    await apiClient.get(endpoints.payments.timeline(paymentId)),
    endpoints.payments.timeline(paymentId),
  );
}
